import { atom } from "jotai";

export const purchaseFormAccordion = atom<string | false>(false);
export const purchaseFormProductsRefs = atom<
  Record<string, { current: HTMLDivElement }>
>({});
